import { render } from "./Mainpage.vue?vue&type=template&id=2498fa36"
import script from "./Mainpage.vue?vue&type=script&lang=js"
export * from "./Mainpage.vue?vue&type=script&lang=js"

import "./Mainpage.vue?vue&type=style&index=0&id=2498fa36&lang=css"

import exportComponent from "C:\\Users\\ken\\Documents\\GitHub\\KasongNursingHome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__